import { render, staticRenderFns } from "./top_videos.vue?vue&type=template&id=12db7b6c"
import script from "./top_videos.vue?vue&type=script&lang=js"
export * from "./top_videos.vue?vue&type=script&lang=js"
import style0 from "./top_videos.vue?vue&type=style&index=0&id=12db7b6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Slider: require('/home/forge/meidenvanholland.nl/components/slider.vue').default})
